// Single source of truth for everything customer-visible that names the product.
// Internal Rakazo identifiers (`@rakazo/*`, `RAKAZO_*`, DB and container names)
// stay unchanged so upstream updates keep merging cleanly.
export const brand = {
  id: "booro",
  name: "BOORO",
  // The languages BOORO speaks live in @booro/locale.
  tagline: {
    en: "Your office has good spirits now.",
    de: "Dein Büro hat jetzt gute Geister.",
  },
  supportEmail: "support@booro.example",
  webOrigin: "https://app.booro.io",
  siteOrigin: "https://booro.io",
  // The website has to serve these pages before launch.
  legal: {
    privacy: "https://booro.io/datenschutz/",
    terms: "https://booro.io/agb/",
  },
  primaryColor: "#A7FF3F",
  themeDefault: "system",
  supportedThemes: ["system", "light", "dark"],
  mascotFamily: "boo-crew",
  mascotColorIds: [
    "pearl",
    "iris",
    "mint",
    "tangerine",
    "lagoon",
    "cobalt",
    "honey",
    "taupe",
    "coral",
    "berry",
    "slate",
  ],
} as const;

export type Brand = typeof brand;
